export enum CashprizeStatusEnum {
  PAYOUT = 'PAYOUT',
  READY_PAYOUT = 'READY_PAYOUT',
  SENT = 'SENT',
  WAIT = 'WAIT',
}
